import { render, staticRenderFns } from "./CreateOrEdit.vue?vue&type=template&id=3e74e027&scoped=true&"
import script from "./CreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./CreateOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrEdit.vue?vue&type=style&index=0&id=3e74e027&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e74e027",
  null
  
)

export default component.exports